
import tables_title_zh from "./tables_title/tables_title_zh"
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'

import user_management_zh from "./user_management/user_management_zh"
import role_management_zh from "./role_management/role_management_zh"
import dept_management_zh from "./dept_management/dept_management_zh"
import posts_management_zh from "./posts_management/posts_management_zh"
import dict_management_zh from "./dict_management/dict_management_zh"
import menu_management_zh from "./menu_management/menu_management_zh"
import notice_management_zh from "./notice_management/notice_management_zh"
import tenant_management_zh from "./tenant_management/tenant_management_zh"

const zh = {
  global: {
    home: '首页',
    service_process: '服务过程管理',
    system: '系统管理',
    wechat: '小程序管理',
    users: '用户管理',
    roles: '角色管理',
    depts: '部门管理',
    building: '楼栋管理',
    posts: '职位管理',
    dict_type: '字典管理',
    menus: '菜单管理',
    orders_management: '陪护管理',
    appointment_management: '预约管理',
    appointment_details: '预约单详情',
    contract_management: '备案管理',
    login_log: '登录日志',
    business_log: '业务日志',
    messages: '通知管理',
    tenants: '租户管理',
    search: '搜索',
    add: '添加',
    add_project: '新增项目',
    add_patient: '新增患者',
    create: '创建',
    back: '返回',
    export: '导出',
    expand_all: '展开所有',
    clear_log: '清空日志',
    modify: '修改',
    delete: '删除',
    details: '详情',
    operation: '操作',
    submit: '提交',
    cancel: '取消',
    logout: '退出',
    confirm: '确认',
    look: '查看',
    change_password: '修改密码',
    old_password: '旧密码',
    new_password: '新密码',
    empty_old_pwd: '请输入旧密码',
    empty_new_pwd: '请输入新密码',
    modified_success: '修改成功',
    added_success: '添加成功',
    del_success: '删除成功',
    select_export: '请选择需要导出的数据',
    table_data_title: '数据表格',
    tips: '提示',
    empty_sort: '请输入排序',
    patient_management: '住院信息',
    edit: '编辑',
    reset: '重置',
    edit_index: '编辑指标',
    go_back: '返回',
    look_model_fill_in_ed: '查看已填报模型',
    edit_relevance_model: '编辑关联模型',
    look_relevance_model: '查看关联模型',
    export_data: '导出数据',
    statistic_analysis: '数据大屏',
    home_page: '数据大屏',
    write_astrict: '填写限制',
    verify_index_var: '校验指标变量',
    app_manage: 'app管理',
    copy: '复制',
    grading_management: '星级管理',
    accompanying: '陪护人员',
    order_details: "订单详情",
    accompaniment_order: "新增陪护人员",
    patient_info: '患者信息',
    patient_details: '详细',
    personnel_details: '照护记录',
    accompanying_management: "人员档案",
    accompanying_type_management: "陪护预警",
    caregiver_post_management: "护理员分类",
    accompanying_details: "档案详情",
    accompanying_history: "照护记录",
    grading_criteria: '星级标准',
    grading_gmanage: '标准制定',
    company_management: '公司管理',
    scale_management: '调查表模板',
    certificate_management: '证书管理',
    certificate_type_management: '证书类型',
    care_level_management: "护理级别",
    care_level_price_management: "收费标准",
    care_level_detail_management: "服务收费",
    care_record_management: "服务明细",
    care_level_type_management: "护理模式",
    workers_discount_management: "职工折扣",
    care_star_price_management: '星级收费标准',
    class_type_management: '班种管理',
    class_group_management: '班组管理',
    class_scheduling_management: '人员排班',
    banner_management: '轮播图管理',
    news_management: '资讯管理',
    complain_management: '投诉管理',
    company_reports: "分析报表",
    // system_reports: "系统报表",
    bed_management: "床号管理",
    personnel_management:"人员管理",
  },
  tables_title: tables_title_zh,
  ...elementZhLocale,
  user_management: user_management_zh,
  role_management: role_management_zh,
  dept_management: dept_management_zh,
  posts_management: posts_management_zh,
  dict_management: dict_management_zh,
  menu_management: menu_management_zh,
  notice_management: notice_management_zh,
  tenant_management: tenant_management_zh,
}

export default zh



// WEBPACK FOOTER //
// ./src/common/lang/zh.js